import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconPredictedRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.363 0 13.334 5.969 13.334 13.333S23.364 29.333 16 29.333 2.667 23.364 2.667 16 8.637 2.666 16 2.666M14.22 21.5a1.334 1.334 0 0 0 0 2.666h3.555a1.333 1.333 0 1 0 0-2.666zM16 7.667a5.482 5.482 0 0 0-3.201 9.93.5.5 0 0 1 .09.088v1.389c0 .736.596 1.333 1.332 1.334h3.556c.736 0 1.334-.598 1.334-1.334v-1.388q.008-.012.024-.031a1 1 0 0 1 .066-.058 5.48 5.48 0 0 0 2.281-4.45A5.483 5.483 0 0 0 16 7.668" /></svg>;
export default SvgIconPredictedRoundedFilledSmall;